import { DefaultButton, Icon } from '@fluentui/react';
import * as React from 'react'
import { useState } from 'react';
import { OptionModel } from '../../home/models/OtherTypes';
import { Utils } from './Utils';

type MenuPickerProps = {
    options: OptionModel[];
    setOptions: (newOptions: OptionModel[]) => void;
    onChange: (status: any) => void;
}

export default function MenuPicker({ options, setOptions, onChange }: MenuPickerProps) {
    const [current, setCurrent] = useState<OptionModel | undefined>(undefined);

    const onClick = (option: OptionModel) => {
        setCurrent(option);

        //for (let i = 0; i < options.length; i++) {
        //    const current = options[i].key === option.key;
        //    options[i].current = current;
        //}

        //setOptions(options);
        onChange(option.key);
    }

    const createMenuItems = () => {
        return options.map((option: OptionModel) => {
            return {
                key: option.key,
                onClick: () => onClick(option),
                text: option.text
            };
        });
    }

    return <>
        <DefaultButton
            menuProps={{
                shouldFocusOnMount: true,
                items: createMenuItems()
            }}
            className="context-menu-text"
            styles={{
                root: { height: 40, minWidth: 40, width: 40 },
                menuIcon: { display: "none !important" }
            }}
            style={{ backgroundColor: "white" }}
        >
            <span className="font-medium font-bold mt--3">{current?.text.charAt(0) ?? "A"}</span>
            {/*<Icon iconName="BulletedListTextMirrored" />*/}
        </DefaultButton>
    </>;
}